import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetReadyOffersSelector } from 'selectors/testTarget/offers/testTargetReadyOffersSelector';

const persistFiltersOnSearchSelector = createSelector(testTargetReadyOffersSelector, offers => offers.persistFiltersOnSearch || Empty.Object);

export { persistFiltersOnSearchSelector };
